export const manualInputDateFormats =
{
    0: 'HH:mm:ss',
    1: 'HH:mm',
    2: 'MM-DD HH:mm',
    3: 'YYYY-MM-DD ',
    4: 'YYYY-MM-DD',
    5: 'YYYY-MM-DD',
    6: 'YYYY'
};